import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent, Platform } from '@ionic/angular';

import { Navigator } from 'src/app/components/menu/navigator';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { DepositMainModel } from 'src/app/models/deposit-models';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { DepositService } from 'src/app/services/cashier/deposit.service';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { CashierBase } from '../../cashier-base/cashier-base';
import { isUndefined } from 'src/app/services/codeUtils';
import { DEPOSIT_PATTERN } from 'src/app/services/customFormValidators';
import { ApplePay, IOrder, ITransactionStatus } from '@ionic-native/apple-pay/ngx';
// import { ApplepayService } from 'src/app/services/applepay/applepay.service';

@Component({
  selector: 'app-deposit-applepay',
  templateUrl: './deposit-applepay.component.html',
  styleUrls: ['./deposit-applepay.component.scss'],
})
export class DepositApplepayComponent extends CashierBase implements OnInit {

  @ViewChild(IonContent, { static: false }) content: IonContent;

  @Input() public navigateBackPage: any;

  public bonusCode: string;
  public customer: any;
  public defaultAmounts: any = [];
  public error = null;
  public labels: DepositMainLabels;
  public minAmount: any;
  public paymentType: any = [];
  public paymentRequestID: any;
  public vendorLogoUrl: string = '';
  public buttonDisabled: boolean = false;
  private isPaymentProcessing: boolean = false;

  public depositForm: FormGroup;
  public amount: AbstractControl;

  constructor(
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    public config: ConfigService,
    public depositService: DepositService,
    public events: EventsService,
    public navigator: Navigator,
    public platform: Platform,
    public UserSessionService: UserSessionService,
    public successMessageService: SuccessMessageService,
    private applePay: ApplePay
  ) {
    super();
    this.successMessageService.clearMessage();
    this.labels = new DepositMainModel();
    this.getCustomer();
  }

  ngOnInit() {
    this.cashierContentService.bonusOfferValue.subscribe(res => this.bonusCode = res);

    this.depositForm = new FormGroup({
      amount: new FormControl({ value: '', disabled: false }, { validators: [Validators.pattern(DEPOSIT_PATTERN), Validators.required], updateOn: 'change' }),
    });
    this.buttonDisabled = false;
    this.amount = this.depositForm.get("amount");
  }

  ngAfterViewInit() {
    this.cashierContentService.getPageConfig('applepay').then((response: DepositMainLabels) => {
      this.labels = response;
    });
  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();
    this.cashierService.getActivePaymentTypes('VVAP').subscribe((response: any) => {
      if (response.result) {
        this.paymentType = response.payload;
        if (!isUndefined(this.paymentType) && this.paymentType.length > 0) {
          this.minAmount = this.paymentType[0].min;
          this.defaultAmounts = this.cashierContentService.getDefaultPayments(this.paymentType, 0);
        }
      }
    }, (error) => console.log("Type category error", error));
  }

  private getCustomer() {
    this.UserSessionService.getCustomerSubscription().then((customerSubscription) => {
      customerSubscription.subscribe((customer) => {
        this.customer = customer;
      });
    });
  }

  public selectedDepositBonusOffer($event): void {
    this.bonusCode = $event.selectedbonusOffer.campaign_code;
  }

  public onAmountSelected(data) {
    return this.depositForm.get('amount').setValue(data);
  }

  onSubmit() {
    this.buttonDisabled = true;
    this.error = null;
    this.successMessageService.clearMessage();

    const amount = parseFloat(this.depositForm.get('amount').value);
    if(amount && amount >= 1) {
      this.payWithApplePay(amount.toFixed(2)) ;
    } else {
      this.buttonDisabled = false;
    }
  }

  onBack = () => {
    this.cashierContentService.onBackHandler(this.navigateBackPage);
  }

  private async payWithApplePay(amount) {
    const merchantIdentifier = this.config.getConfig().APPLEPAY_MERCHANT_IDENTIFIER || 'merchant.com.palainteractive.prelive';
    const supportedNetworks = this.config.getConfig().APPLEPAY_SUPPORTED_NETWORKS || ['visa', 'amex', 'masterCard'];
    const merchantCapabilities = this.config.getConfig().APPLEPAY_MERCHANT_CAPABILITIES || ['3ds', 'credit', 'debit', 'emv'];
    const currencyCode = this.config.getConfig().DEFAULT_CURRENCY || 'USD';
    const countryCode = this.config.getConfig().APPLEPAY_COUNTRY_CODE || 'US';
    const merchantName = this.config.getConfig().APPLEPAY_MERCHANT_NAME || 'Stardust Casino';
    const itemLabel = this.config.getConfig().APPLEPAY_ITEM_LABEL || 'Deposit to app wallet';
    try {         
      const isApplepayAvailable = await this.applePay.canMakePayments();
      if (isApplepayAvailable)  {
        const paymentRequest: IOrder = {
          merchantIdentifier: merchantIdentifier,
          currencyCode: currencyCode,
          countryCode: countryCode,
          supportedNetworks: supportedNetworks,
          merchantCapabilities: merchantCapabilities,
          billingAddressRequirement: 'none',
          shippingAddressRequirement: 'none',
          items: [{label: itemLabel, amount: amount}, {label: merchantName, amount: amount}],
        };

        const applePayTransaction = await this.applePay.makePaymentRequest(paymentRequest);
        this.isPaymentProcessing = true;

        if(applePayTransaction && applePayTransaction.paymentData) {
          const merchantResponse: ITransactionStatus = await this.callDeposit(applePayTransaction, amount);  
          const result = await this.completeTransaction(merchantResponse);
          if (result) {            
            setTimeout(() => {
              this.checkDeposit(amount);    
            }, 500);
          }
        } else {
          this.handleApplepayError("Invalid apple pay transaction response");
        }
      }
    } catch(error) {
      this.handleApplepayError(error);
    }
  }

  private async handleApplepayError(error) {    
    console.error(error);
    if(this.isPaymentProcessing) {
      this.completeTransaction("failure");
    }
    this.buttonDisabled = false;
    this.navigator.navigateTo( "DepositSuccessFailureComponent",{}, { status: false, flag: "applepay", message: this.error || error });
  }

  private async completeTransaction(merchantResponse: any) {
    const result = await this.applePay.completeLastTransaction(merchantResponse);
    this.isPaymentProcessing = false;
    return result;
  }

  parsePaymentResponse(responseString: string): any {
    try {
      const convertedJson: ApplePayTransaction = JSON.parse(responseString);
      return convertedJson;
    } catch (error) {
      console.error('Error parsing JSON:', error);
    }
  }

  private async callDeposit(applepayResponse, amount: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const paymentData: ApplePayTransaction = this.parsePaymentResponse(applepayResponse.paymentData);
      if(paymentData) {
        let depositObj: any = this.depositForm.value;
        depositObj.amount = amount;
        depositObj.payment_type_code = 'VVAP';
        depositObj.currency_code = this.customer.preferredCurrency.currencyCode;
        depositObj.appleData = paymentData;
        if (this.bonusCode != "") depositObj.bonusCode = this.bonusCode;

        this.cashierService.callApplepayDeposit(depositObj).subscribe((response) => {
          if(response && !!response.result) {
            this.paymentRequestID = response.payload.paymentRequestID;
            if (!('hasExceededDepositLimit' in response.payload)) {
              resolve("success");  
              return;
            }
          }
          resolve("failure");
        }, error => {
          this.error = error.error_payload;
          resolve("failure");
        });
      } else {
        reject("failure");
      }      
    })
  }

  private checkDeposit(amountSubmitted) {
    if (!isUndefined(this.paymentRequestID)) {
      this.depositService
        .checkDepositStatus(this.paymentRequestID)
        .subscribe(
          (response) => {
            if (!isUndefined(response.payload)) {
              switch (response.payload.status) {
                case "APPROVED":
                  let depositLimitExceeded = false;

                  if ("hasExceededDepositLimit" in response.payload) {
                    depositLimitExceeded =
                      response.payload.hasExceededDepositLimit;
                  }

                  if (depositLimitExceeded) {
                    this.navigator.navigateTo(
                      "DepositThresholdComponent",
                      {},
                      {
                        status: true,
                        amount: amountSubmitted,
                        customerId: this.cashierService.customer.customerId,
                      }
                    );
                    break;
                  }

                  this.navigator.navigateTo(
                    "DepositSuccessFailureComponent",
                    {},
                    { status: true, flag: "applepay" }
                  );
                  break;
                case "IN PROCESS":
                  this.navigator.navigateTo(
                    "DepositSuccessFailureComponent",
                    {},
                    {
                      status: true,
                      navigateBackPage: "DepositApplepayComponent",
                      flag: "applepay",
                      message:
                        "Your deposit transaction is still in progress.<br/>Please check your account or contact customer support.",
                    }
                  );
                  break;
                case "CANCELLED":
                  this.navigator.navigateTo(
                    "DepositSuccessFailureComponent",
                    {},
                    {
                      status: false,
                      navigateBackPage: "DepositApplepayComponent",
                      flag: "applepay",
                      message: "Your deposit transaction did not succeed.",
                    }
                  );
                  break;
                default:
                  this.navigator.navigateTo(
                    "DepositSuccessFailureComponent",
                    {},
                    {
                      status: false,
                      navigateBackPage: "DepositApplepayComponent",
                      flag: "applepay",
                      message:
                        "Your deposit transaction could not be processed.",
                    }
                  );
                  break;
              }
              return;
            }
            return this.navigator.navigateTo(
              "DepositSuccessFailureComponent",
              {},
              {
                status: false,
                flag: "applepay",
                navigateBackPage: "DepositApplepayComponent",
              }
            );
          },
          (error) => {
            return this.navigator.navigateTo(
              "DepositSuccessFailureComponent",
              {},
              {
                status: false,
                flag: "applepay",
                navigateBackPage: "DepositApplepayComponent",
              }
            );
          }
        );
        this.buttonDisabled = false;
    }
  }
}

export interface ApplePayTransaction {
    data: string;
    signature: string;
    header: {
      publicKeyHash: string;
      ephemeralPublicKey: string;
      transactionId: string;
    };
    version: string;
}